import { RootState } from '../../modules'
import { useReduxSelector } from '..'

export const useHasBillerUnit = () => useReduxSelector((state: RootState) => state.propertyLinking).unit?.unit
